/* tslint:disable:only-arrow-functions */

import { JWT_OPTIONS, JwtModule } from '@auth0/angular-jwt';
import { environment } from '../../environments/environment';

export function jwtOptionsFactory() {
  return {
    tokenGetter: () => {
      return localStorage.getItem('JWT_TOKEN');
    },
    whitelistedDomains: [
      environment.baseUrl.match(/:\/\/(.*)$/)[1],
      environment.baseUrlv2.match(/:\/\/(.*)$/)[1],
    ],
  };
}

export const AppJwtModule = JwtModule.forRoot({
  jwtOptionsProvider: {
    provide: JWT_OPTIONS,
    useFactory: jwtOptionsFactory,
  },
});



// WEBPACK FOOTER //
// ./src/app/resources/jwt.module.ts